import { DataStorage } from '@studyportals/data-storage';
import store from '@/store';

const GAI_QUESTIONNAIRE_TAKEN_STORAGE_KEY
	= 'global_access_initiative_questionnaire_taken';
export class DataStorageSyncPlugin {
	public initiate(): void {
		this.syncGlobalAccessInitiativeQuestionnaireStatus();
	}

	private syncGlobalAccessInitiativeQuestionnaireStatus(): void {
		store.mutations.setGAIQuestionnaireTaken(DataStorage.retrieve(GAI_QUESTIONNAIRE_TAKEN_STORAGE_KEY) === 'true');
	}
}
